import axios from '../index';

export const requestUserData = ({ id, type }) => axios.get(`/fhir/${type}/${id}`);

export const requestPutUserData = ({ id, type, resource }) =>
  axios.put(`/fhir/${type}/${id}`, resource);

export const requestChangePassword = ({ currentPassword, newPassword }) =>
  axios.put('/user-management/password', { currentPassword, newPassword });

export const requestSendFeedback = ({ category, message }) =>
  axios.post('/notification', { category, message });
